export enum CacheKeyEnum {
  mainToken = "c-internal-token",
  storeList = "internal-store-list",
  mobilePackage = "internal-mobile-package",
  nationListForFilter = "internal-nation-list",
  simMobilePlanPakage = "internal-sim-mobile-package",
  inboundPakcage = "internal-inbound-package",
  serviceList = "internal-service-list",
  partnerList = "internal-partner-list",
  internalFeature = "internal-features",
  simEcommercePackage = "internal-sim-ecommerce-package",
  carrierList = "internal-carrier-list",
  modalErrorCode = "internal-modal-error-code",
  userStore = "internal-user-store",
  b2cPartner = "internal-b2c-partner",
  userChain = "internal-user-chain",
  carrierForPackage = "internal-carrier-for-package",
  categoryListForPackage = "internal-category-for-package",
  capabilities = "internal-service-capabilities",
  userMenu = "intenal-user-menu",
  filterMenu = "internal-menu-for-filter",
  user = "user",
  zodiac = "internal-zodiac-list",
  destiny = "internal-destiny-list",
  numerology = "internal-numerology-list",
  provider = "internal-provider-list",
  partnerOfUser = "internal-partner-of-user",
  language = "internal-language"
}
